export let currRowId = 1;

export function nextRowId() {
  return "quote_row_" + currRowId++;
}

export function normalizePrice(input) {
  if (!input) input = 0;
  input = input.toString().replace(/,/g, '.');

  input = input.toString().replace(/ /g, '');
  let segments = input.split('.');
  if (segments.length > 1) {

    let last = segments.splice(segments.length - 1, 1)[0];
    input = segments.reduce(function (p, c) {
      return p + c;
    }, '') + "." + last;

  }
  return +input;
}

export function calcTotalPrice(price, quantity, discount, labour) {
  price = +price;
  quantity = +quantity;
  if (!discount) {
    discount = 0;
  } else {
    discount = +discount;
  }
  if (!labour) {
    labour = 0;
  } else {
    labour = +labour;
  }
  return (1 + labour / 100 - discount / 100) * price * quantity;
}